import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { makeStyles } from 'design-system/styles';

function ExecutionTableFooter(props: {
  selectedPage: number;
  setSelectedPage: (page: number) => void;
  lastPage?: boolean;
}) {
  const { selectedPage, setSelectedPage, lastPage } = props;
  const classes = styles();

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '.5rem',
      }}
    >
      <p style={{ margin: 0, paddingLeft: '.5rem' }}>
        Page <b>{selectedPage + 1}</b>
      </p>
      <div style={{ display: 'flex' }}>
        {selectedPage > 1 && (
          <button className={classes.tableButton} onClick={() => setSelectedPage(0)}>
            <FontAwesomeIcon icon={`chevron-double-left`} />
          </button>
        )}
        {selectedPage !== 0 && (
          <button className={classes.tableButton} onClick={() => setSelectedPage(selectedPage - 1)}>
            <FontAwesomeIcon icon={`chevron-left`} />
          </button>
        )}
        {!lastPage && (
          <button className={classes.tableButton} onClick={() => setSelectedPage(selectedPage + 1)}>
            <FontAwesomeIcon icon={`chevron-right`} />
          </button>
        )}
      </div>
    </div>
  );
}

const styles = makeStyles({
  tableButton: {
    background: 'none',
    border: 'none',
    height: '33px',
    width: '33px',
    cursor: 'pointer',
    borderRadius: '2rem',
    '&:hover': {
      background: 'lightgrey',
    },
  },
});

export default ExecutionTableFooter;
